import {  Injectable } from "@angular/core";
import { Wizard } from "src/app/core/wizard/wizard";
import { LowPopulationAlertComponent } from "./low-population-alert/low-population-alert.component";

// new-popup-wizard.ts
@Injectable({
  providedIn: 'root'
})
export class LowPopulationAlertWizard extends Wizard<any>  {
  key = 'low-population';
  pageTypeMap:any = {
    'low-population': LowPopulationAlertComponent,
  };

  startingPageKey = 'low-population';

  constructor() {
    super();
    this.width = 500;
  }

}
